import { render } from "./Toggle.vue?vue&type=template&id=f6b736c8&scoped=true&ts=true&lang=pug"
import script from "./Toggle.vue?vue&type=script&lang=ts"
export * from "./Toggle.vue?vue&type=script&lang=ts"

import "./Toggle.vue?vue&type=style&index=0&id=f6b736c8&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b736c8"]])

export default __exports__